// Project: GSSC Pilot Front-end
// Filename: store.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.

/* eslint no-param-reassign: "off" */

import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import VueCookies from 'vue-cookies';
Vue.use(Vuex);
Vue.use(VueCookies);

Vue.$cookies.config('1d', '/', '.' + window.location.hostname, false);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    roles: [],
    labsNeedRefresh: false,
    selection: {
      selectAll: false,
      assets: []
    }
  },

  mutations: {
    authUser(state, userData) {
      state.token = userData.token;
      state.user = userData.user;
      state.roles = userData.roles;
      // console.log('REDIRECT - STORE - TOKEN SAVED !!!');
    },
    clearAuthData(state) {
      state.token = null;
      state.user = null;
      state.roles = [];
    },
    renewToken(state, token) {
      // console.log('LOGIN - HAY UN RENEW TOKEN', token);
      state.token = token;
    },
    labsNeedRefresh(state, value) {
      state.labsNeedRefresh = value;
    },
    newSelectAll(state, value) {
      state.selection.selectAll = value;
    },
    newSelection(state, value) {
      state.selection.assets = value;
    }
  },
  actions: {
    saveSelectAll({ commit }, selectAll) {
      commit('newSelectAll', selectAll);
    },
    saveSelection({ commit }, assets) {
      commit('newSelection', assets);
    },
    saveLogin({ commit }, authData) {
      localStorage.setItem('token', authData.token);
      localStorage.setItem('user', authData.user);
      localStorage.setItem('roles', authData.roles);
      Vue.$cookies.set('session_id', authData.token);
      // console.log('SAVELOGIN: COOKIE_STORED_IS:', Vue.$cookies.get('session_id'));
      commit('authUser', {
        token: authData.token,
        user: authData.user,
        roles: authData.roles
      });
    },
    tryAutoLogin({ commit }) {
      const token = localStorage.getItem('token');
      // console.log('TRYAUTOLOGIN: COOKIE_STORED_IS:', Vue.$cookies.get('session_id'));
      const user = localStorage.getItem('user');
      const roles = localStorage.getItem('roles');
      if (!token || !user || !roles) {
        console.log('LOGIN ITEMS REMOVED');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('roles');
        return;
      }
      commit('authUser', {
        token: token,
        user: user,
        roles: roles
      });
    },
    logout({ commit }) {
      commit('clearAuthData');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('roles');
      Vue.$cookies.remove('session_id');
      // router.replace('/');
    },
    renewToken({ commit }, token) {
      // Check if we still have user and roles
      if (this.state.user && this.state.roles.length > 0) {
        commit('renewToken', token);
        localStorage.setItem('token', token);
        Vue.$cookies.set('session_id', token);
      }
    },
    labsNeedRefresh({ commit }, value) {
      commit('labsNeedRefresh', value);
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.token !== null;
    },
    roles(state) {
      return state.roles;
    },
    isSelf(state) {
      return state.roles.includes('GSSC - SelfRegistration');
    },
    isAdministrator(state) {
      return state.roles.includes('GSSC - Administrators');
    },
    isUser(state) {
      return state.roles.includes('GSSC - Users');
    },
    labsNeedRefresh(state) {
      return state.labsNeedRefresh.value;
    },
    storedSelectAll(state) {
      return state.selection.selectAll;
    },
    storedSelection(state) {
      return state.selection.assets;
    }
  }
});
